import React from 'react';
import Grid from '@amzn/awsui-components-react/polaris/grid';
import Header from '@amzn/awsui-components-react/polaris/header';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import { EventList as BetterEventList } from '../components/better/eventList';
import { BetterSideNav } from '../components/sideNav';
import { TopSearchFilters } from '../components/better/topSearchFilters';
import { MoreWaysFooter } from '../components/moreWaysFooter';
import { ScrollToTopButton } from '../components/scrollToTopButton';
import { useLocalizedText } from '../hooks/localizedText';
import { useSearchParams } from 'react-router-dom';
import { featureIsEnabled, useFeatures } from '../hooks/features';
import { NAVIGATION_REDESIGN } from '../utils/constants';

export function Home() {
  const { t } = useLocalizedText(['translation']);
  const [searchParams] = useSearchParams();
  const features = useFeatures();
  const isNewNav = featureIsEnabled(NAVIGATION_REDESIGN, features, searchParams);

  // New layout: top filters above full-width event list
  if (isNewNav) {
    return (
      <div className="page-content">
        <SpaceBetween direction="vertical" size="m">
          <Header variant="h1">{t('topFilters.searchHeader')}</Header>
          <TopSearchFilters />
        </SpaceBetween>
        <BetterEventList />
        <ScrollToTopButton />
      </div>
    );
  }

  // Legacy layout: side filters + event list in grid
  return (
    <>
      <div className="page-content">
        <div className="page-content-header">
          <Header variant="h1">{t('search.header')}</Header>
        </div>
        <Grid
          gridDefinition={[
            { colspan: { default: 12, xl: 3, l: 4, m: 4, s: 5 } },
            { colspan: { default: 12, xl: 9, l: 8, m: 8, s: 7 } },
          ]}
        >
          <BetterSideNav />
          <BetterEventList />
        </Grid>
      </div>
      <MoreWaysFooter />
    </>
  );
}
